// extracted by mini-css-extract-plugin
export var header = "_j2-0";